export default __webpack_public_path__ + "static/media/LOGO_ERC-FLAG_EU_cropped.416e9369.jpg";